export const translations = {
  es: {
    // Generales
    'app.title': 'Mi Aplicación',
    'app.subtitle': 'Subtítulo de la aplicación',
    
    // Navegación
    'nav.home': 'Inicio',
    'nav.about': 'Acerca de',
    'nav.contact': 'Contacto',
    
    // Botones
    'button.changeTheme': 'Cambiar tema',
    'button.changeLanguage': 'Cambiar idioma',
    'button.save': 'Guardar',
    'button.cancel': 'Cancelar',
    
    // Footer
    'footer.rights': 'Todos los derechos reservados',
    
    // Home
    'home.welcome': '¡Bienvenido a mi aplicación!',
    'home.description': 'Esta es una aplicación moderna con soporte para múltiples idiomas y tema oscuro.'
  },
  
  en: {
    // General
    'app.title': 'My Application',
    'app.subtitle': 'Application subtitle',
    
    // Navigation
    'nav.home': 'Home',
    'nav.about': 'About',
    'nav.contact': 'Contact',
    
    // Buttons
    'button.changeTheme': 'Change theme',
    'button.changeLanguage': 'Change language',
    'button.save': 'Save',
    'button.cancel': 'Cancel',
    
    // Footer
    'footer.rights': 'All rights reserved',
    
    // Home
    'home.welcome': 'Welcome to my application!',
    'home.description': 'This is a modern application with support for multiple languages and dark theme.'
  }
}